import * as React from 'react';
import { Text } from '../Text';
import { PICKER_DATA_HOOKS, PICKER_DATA_PROPS } from './dataHooks';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '../IconButton';
import { st, classes } from './Picker.st.css';
const Picker = (props) => {
    const { onPrev, value, onNext, prevDisabled, nextDisabled, prevAriaLabel, nextAriaLabel, className, } = props;
    const getDataAttributes = () => {
        return {
            [PICKER_DATA_PROPS.NextDisabled]: nextDisabled,
            [PICKER_DATA_PROPS.PrevDisabled]: prevDisabled,
        };
    };
    return (React.createElement("div", { "data-hook": props['data-hook'], className: st(classes.root, {}, className), ...getDataAttributes() },
        React.createElement(IconButton, { className: classes.arrow, icon: React.createElement(ChevronLeft, null), onClick: () => (prevDisabled ? null : onPrev()), disabled: prevDisabled, "data-hook": PICKER_DATA_HOOKS.Prev, title: PICKER_DATA_HOOKS.Prev, "aria-label": prevAriaLabel }),
        React.createElement(Text, { role: "status", className: classes.value }, value),
        React.createElement(IconButton, { className: classes.arrow, icon: React.createElement(ChevronRight, null), onClick: () => (nextDisabled ? null : onNext()), disabled: nextDisabled, "data-hook": PICKER_DATA_HOOKS.Next, title: PICKER_DATA_HOOKS.Next, "aria-label": nextAriaLabel })));
};
Picker.defaultProps = {
    prevDisabled: false,
    nextDisabled: false,
    prevAriaLabel: '',
    nextAriaLabel: '',
};
export { Picker };
//# sourceMappingURL=Picker.js.map